<div class="timeline-toolbar">
    <mat-form-field appearance="outline" class="search-field custom-mat-field" subscriptSizing="dynamic">
        <mat-icon matPrefix>search</mat-icon>
        <input matInput (keyup)="applyFilter($event)" placeholder="Search action, user, field or value" />
    </mat-form-field>

    <div class="toolbar-actions">
        <span *ngIf="isLoadingMore" class="loading-status">
            <mat-spinner diameter="16"></mat-spinner>
            {{ isSearchingAll ? 'Searching all entries…' : 'Loading more entries…' }}
        </span>
        <span class="stat">
            <strong>{{ dataSource.data.length }}{{ hasMore ? '+' : '' }}</strong> loaded
        </span>
        <span class="stat stat--match" *ngIf="searchTerm">
            <strong>{{ dataSource.filteredData.length }}</strong> matches
        </span>
        <mat-slide-toggle color="primary" [checked]="showFunctions" (change)="toggleFunctions($event.checked)"
            matTooltip="Show or hide function_executed, workflow_rule and functions entries">
            Show functions
        </mat-slide-toggle>
        <button mat-stroked-button (click)="toggleSort()" [matTooltip]="sortDesc ? 'Showing newest first' : 'Showing oldest first'">
            <mat-icon>{{ sortDesc ? 'arrow_downward' : 'arrow_upward' }}</mat-icon>
            {{ sortDesc ? 'Newest' : 'Oldest' }}
        </button>
        <button *ngIf="isSearchingAll" mat-stroked-button color="warn" (click)="stopSearch()">
            <mat-icon>stop</mat-icon> Stop
        </button>
        <button mat-icon-button color="primary" matTooltip="Refresh" (click)="loadTimeline()" [disabled]="isLoading || isLoadingMore">
            <mat-icon>refresh</mat-icon>
        </button>
    </div>
</div>

<div *ngIf="isLoading" class="timeline-loader">
    <mat-spinner diameter="32"></mat-spinner>
</div>

<div *ngIf="errorMessage" class="banner banner--error">
    <mat-icon>error_outline</mat-icon>
    <span>{{ errorMessage }}</span>
</div>

<div *ngIf="searchTerm && hasMore && !isSearchingAll && !isLoading" class="banner banner--info">
    <mat-icon>info_outline</mat-icon>
    <span>Search stopped. Results only cover the {{ dataSource.data.length }} entries loaded so far.</span>
    <button mat-button color="primary" (click)="continueSearch()">Continue search</button>
</div>

<div class="feed" [hidden]="isLoading">
    <ng-container *ngFor="let row of rows$ | async; let i = index; let rows = ngForOf; trackBy: trackRow">
        <div class="day-header" *ngIf="i === 0 || rows[i - 1].dayKey !== row.dayKey">
            <span class="day-label">{{ row.auditedTime | date : 'EEEE, MMM d, y' }}</span>
        </div>

        <div class="entry">
            <div class="time" [matTooltip]="row.auditedTime | date : 'MMM d, y hh:mm:ss a'">
                {{ row.auditedTime | date : 'hh:mm a' }}
            </div>
            <div class="rail">
                <span class="marker" [ngClass]="'marker--' + row.actionKind">
                    <mat-icon>{{ actionIcons[row.actionKind] }}</mat-icon>
                </span>
            </div>

            <div class="entry-card">
                <div class="entry-head">
                    <div class="entry-summary">
                        <div class="headline">
                            <span class="who"><ng-container *ngTemplateOutlet="hl; context: { $implicit: row.doneBy || 'Unknown user' }"></ng-container></span>
                            <span class="action" [ngClass]="'action--' + row.actionKind"><ng-container *ngTemplateOutlet="hl; context: { $implicit: row.action }"></ng-container></span>
                            <span class="tag tag--automation" *ngIf="row.automation">
                                <mat-icon>bolt</mat-icon><ng-container *ngTemplateOutlet="hl; context: { $implicit: row.automation }"></ng-container>
                            </span>
                        </div>
                    </div>
                </div>

                <!-- While searching, changes that don't match are dimmed so the matching ones stand out -->
                <div class="changes" *ngIf="row.changes.length" [class.changes--filtered]="hasMatchingChange(row)">
                    <div class="change" *ngFor="let change of row.changes" [class.change--match]="changeMatches(change)">
                        <span class="field"><ng-container *ngTemplateOutlet="hl; context: { $implicit: change.label }"></ng-container></span>
                        <span class="value value--old" [class.value--empty]="change.oldValue === '—'"><ng-container *ngTemplateOutlet="hl; context: { $implicit: change.oldValue === '—' ? 'empty' : change.oldValue }"></ng-container></span>
                        <mat-icon class="arrow">arrow_forward</mat-icon>
                        <span class="value value--new" [class.value--empty]="change.newValue === '—'"><ng-container *ngTemplateOutlet="hl; context: { $implicit: change.newValue === '—' ? 'empty' : change.newValue }"></ng-container></span>
                    </div>
                </div>
            </div>
        </div>
    </ng-container>

    <div class="empty-state" *ngIf="!dataSource.filteredData.length && !isLoading">
        <mat-icon>history</mat-icon>
        <span *ngIf="searchTerm">No entries match your search</span>
        <span *ngIf="!searchTerm && dataSource.data.length">Only function entries loaded so far — they are hidden.</span>
        <span *ngIf="!searchTerm && !dataSource.data.length">No timeline entries found</span>
        <button *ngIf="hasMore && !searchTerm" mat-button color="primary" (click)="loadMore()" [disabled]="isLoadingMore">
            Load more
        </button>
    </div>
</div>

<mat-paginator [hidden]="isLoading" [pageSizeOptions]="[10, 25, 50, 100]" [pageSize]="25" showFirstLastButtons
    (page)="onPageChange($event)"></mat-paginator>

<!-- Renders text with the current search term wrapped in <mark> -->
<ng-template #hl let-text><ng-container *ngFor="let seg of text | highlightSegments : searchTerm"><mark *ngIf="seg.match" class="hit">{{ seg.text }}</mark><ng-container *ngIf="!seg.match">{{ seg.text }}</ng-container></ng-container></ng-template>
